var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.361 14.188L7.146 11m0 0l3.215-3.188M7.146 11h8.574M1.788 11c0-1.256.25-2.5.734-3.66a9.557 9.557 0 012.091-3.102 9.65 9.65 0 013.13-2.073 9.717 9.717 0 017.381 0 9.651 9.651 0 013.129 2.073 9.557 9.557 0 012.09 3.103A9.492 9.492 0 0121.079 11a9.522 9.522 0 01-2.825 6.762 9.687 9.687 0 01-6.82 2.8 9.687 9.687 0 01-6.82-2.8A9.521 9.521 0 011.788 11z",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/media/arrow-left.a17271a8.svg";
export { SvgArrowLeft as ReactComponent };